import useSWR from "swr";
import { getAdminZTokenPackages, type AdminZTokenPackageDto } from "../api/adminEconomyApi";

export default function useAdminZTokenPackages(includeInactive = true) {
  const swr = useSWR<AdminZTokenPackageDto[]>(
    ["admin-z-token-packages", includeInactive],
    () => getAdminZTokenPackages(includeInactive),
    {
      dedupingInterval: 15000,
      revalidateOnFocus: true,
      fallbackData: [],
    },
  );

  return swr;
}
